import React from 'react';
import { useLoginContext } from '../../Contexts/LoginContext';
import { useLocation } from 'react-router-dom';
import { useStoreContext } from '../../Contexts/StoreContext';
import { TbChecklist, TbShoppingBag } from 'react-icons/tb';
import { useCartContext } from '../../Contexts/CartContext';
import SelectedProduct from './Product/SelectedProduct';
import { useCheckoutContext } from '../../Contexts/CheckoutContext';
import BadgeIndicator from './Product/BadgeIndicator';
import { useStoreHook } from '../../Hooks/StoreHook';
import BoxContentStoreOrderTypeHeader from './BoxContentStoreOrderTypeHeader';
import BoxContentSearchHeader from './BoxContentSearchHeader';
import HeaderLogo from './HeaderLogo';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { HiBars3 } from 'react-icons/hi2';
import Button from '../Form/Button';
import { useTranslation } from 'react-i18next';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import ButtonLogin from './ButtonLogin';

const Header = () => {

    const { isAuthenticated, isAuthenticatedToQuickPurchase, isAuthenticatedBySSO } = useLoginContext();
    const { currentStore } = useStoreContext();
    const { isMenu } = useOrderTypeContext();
    const { setShowMainMenu, setShowSearchBar, setShowTodayOrders } = useLayoutContext();
    const { t } = useTranslation();

    const { currentCart, loadingCurrentCart, loadingUpdateQuantity, setShowCart, getTotalQuantityProductsInConference, currentCartHasItems } = useCartContext();
    const { awaitingOrPendingCount } = useCheckoutContext();
    const { getLinkToHome } = useStoreHook();

    const location = useLocation();
    const isHome = location.pathname === getLinkToHome();
    const isProductPage = new RegExp(`^${getLinkToHome().replace('/', '\\/')}/produto/`).test(location.pathname);

    const handleOpenCart = () => {
        setShowCart(true);
    }

    return (
        <header id="boxHeader" className="flex flex-col w-full justify-between sticky bg-custom-header top-0 z-30 text-custom-header-text">
            <section className='flex justify-center h-20 shadow-sm shadow-black/5'>
                <div className="flex p-4 items-center justify-between w-full md:max-w-[1460px] gap-4 md:gap-6">

                    {/* LOGO */}
                    <HeaderLogo className='min-h-20' />

                    <div className='flex items-center justify-end w-full gap-4 md:gap-6'>

                        {/* SEARCH */}
                        <BoxContentSearchHeader show={currentStore && (isHome || isProductPage)} />

                        <div className="flex items-center gap-2 md:gap-4 h-full">
                            <BoxContentStoreOrderTypeHeader sizeButton={22} />

                                <div className="hidden md:flex items-center gap-2 md:gap-2 h-full">
                                    {!isMenu && (
                                        <>
                                            <Button rounded gray onClick={() => {setShowSearchBar(false); setShowTodayOrders(true);}} disabled={!isAuthenticated && !isAuthenticatedToQuickPurchase}>
                                                <div className='relative'>
                                                    <TbChecklist size={23} className='zoomInIconNoDelay' />
                                                    { awaitingOrPendingCount > 0 && <BadgeIndicator quantity={awaitingOrPendingCount} className='absolute -top-3.5 -right-3.5 bg-shopfood-title animate-bounce' />}
                                                </div>
                                            </Button>

                                            <div className='relative'>
                                                <Button
                                                    rounded
                                                    gray
                                                    disabled={!currentCartHasItems}
                                                    onClick={handleOpenCart}
                                                    className='text-custom-primary disabled:text-gray-600'>
                                                    <div><TbShoppingBag size={23} /></div>
                                                    <SelectedProduct alwaysNotify={false} loading={loadingCurrentCart || loadingUpdateQuantity} animated={false} quantity={currentCart ? getTotalQuantityProductsInConference(currentCart.items) : 0} className="rounded-lg -top-0.5 -right-0.5" />
                                                </Button>
                                            </div>

                                            <ButtonLogin 
                                                asButtonGray 
                                                forceSsoLogin={isAuthenticatedBySSO}
                                                withLoading={isAuthenticatedBySSO}
                                                labelLink={t('login.label_button_login')} 
                                            />
                                        </>
                                    )}

                                    <Button 
                                        rounded 
                                        gray
                                        onClick={() => {
                                            React.startTransition(() => {
                                                setShowMainMenu(true);
                                            });
                                        }}
                                        className='hidden md:flex '>
                                        <div><HiBars3 size={23} /></div>
                                    </Button>

                                </div>

                        </div>

                    </div>
                </div>
            </section>

        </header>
    );
};

export default Header;
